
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { SectionHeading } from '@/components/ui/section-heading';

export default function AboutPreview() {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <SectionHeading
              subtitle="About OMAC-UK"
              title="Traditional Values, Modern Training"
              alignment="left"
              className="mb-8"
            />
            
            <p className="text-gray-700 mb-6 leading-relaxed">
              At OMAC-UK, we offer age and experience-specific Taekwondo classes designed to help you grow,
              challenge yourself, and achieve your goals.
            </p>

            <p className="text-gray-700 mb-8 leading-relaxed">
              Our Taekwondo academy in Gedling follows the World
              Taekwondo curriculum, blending MooGongRyu and Hapkido self-defence techniques.
            </p>

            <p className="text-gray-700 mb-8 leading-relaxed">
              Whether you're a beginner or an experienced martial artist, you'll train in a supportive, family-oriented
              environment where parents and children practice together—building skills, confidence,
              and lifelong connections.
            </p>

            <p className="text-gray-700 mb-8 leading-relaxed">
              People join OMAC-UK for many reasons: fitness, self-defence, weight control, improving focus, making new
              friends, or simply having fun. Whatever your motivation, you'll gain so much more—including discipline,
              coordination, and a strong sense of purpose.
            </p>

            <p className="text-gray-700 mb-8 leading-relaxed">
              Join OMAC-UK, Nottingham’s leading Taekwondo Academy, and
              take the first step on a life-changing journey. Your path to strength, confidence,
              and community starts here.
            </p>
            
            <Button size="lg" asChild>
              <Link to="/about">
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
          
          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="rounded-xl overflow-hidden shadow-2xl transform lg:-rotate-2 transition-transform hover:rotate-0">
                <img 
                  src="/images/juliet/juliet_flag.jpeg"
                  alt="OMAC Taekwondo class" 
                  className="w-full h-auto"
                />
              </div>
              
              <div className="absolute -bottom-6 -right-6 w-48 bg-white rounded-lg shadow-lg p-4 transform rotate-3">
                <div className="text-sm text-gray-600 font-medium">Established</div>
                <div className="text-3xl font-bold font-display text-taekwondo-red">2003</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
